import { render, staticRenderFns } from "./CatalogContentAddUpdate.vue?vue&type=template&id=5b68be15&scoped=true"
import script from "./CatalogContentAddUpdate.vue?vue&type=script&lang=js"
export * from "./CatalogContentAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./CatalogContentAddUpdate.vue?vue&type=style&index=0&id=5b68be15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68be15",
  null
  
)

export default component.exports